
import {
	Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

const DEFAULT_MESSAGE = 'There was an error loading this page. Please reload or try again later.';

@Component
export default class PageError extends Vue {
	@Prop({ default: false })
	public isShown!: boolean;

	@Prop({ default: DEFAULT_MESSAGE })
	public message!: string;

	@Prop({ default: true })
	public reload!: boolean;

	@Watch('isShown')
	public watchIsShown(isShown: boolean): void {
		if (isShown) {
			this.disableScroll();
		}
	}

	public disableScroll(): void {
		const body = this.$el.querySelector('body');

		if (body) {
			body.style.overflow = 'hidden';
		}
	}

	// eslint-disable-next-line class-methods-use-this
	reloadPage() {
		window.location.reload();
	}
}
